import { connect } from 'react-redux';
import {actions} from '../../../../../redux/modules/regiones/regiones';
import RegionesGrid from './regionGrid';

const mstp = state => {
    return {...state.regiones, permisos: state.login.me.permisos}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(RegionesGrid)
